<template>
  <UModal
    v-model:open="guideOpen"
    title="Installer l'espace volontaire"
    :description="isIos ? 'Sur iPhone et iPad, l\'installation se fait depuis Safari en 3 gestes.' : 'Ajoute l\'application à ton écran d\'accueil en 2 gestes.'"
  >
    <template #body>
      <ol class="space-y-4">
        <li
          v-for="(step, index) in steps"
          :key="step.title"
          class="flex items-start gap-3"
        >
          <span class="flex size-10 shrink-0 items-center justify-center rounded-full bg-primary/10 text-primary">
            <UIcon
              :name="step.icon"
              class="size-5"
            />
          </span>
          <div>
            <p class="font-semibold text-highlighted">
              {{ index + 1 }}. {{ step.title }}
            </p>
            <p class="text-sm text-muted">
              {{ step.text }}
            </p>
          </div>
        </li>
      </ol>
      <PwaPhoneMockup class="mt-6 w-28" />
    </template>
    <template #footer>
      <UButton
        label="J'ai compris"
        block
        @click="guideOpen = false"
      />
    </template>
  </UModal>
</template>

<script lang="ts" setup>
const { guideOpen, isIos } = usePwa()

const steps = computed(() => isIos.value
  ? [
      { icon: 'i-lucide-share', title: 'Touche « Partager »', text: 'L\'icône carré avec une flèche, en bas de Safari.' },
      { icon: 'i-lucide-square-plus', title: '« Sur l\'écran d\'accueil »', text: 'Fais défiler la liste d\'actions puis valide avec « Ajouter ».' },
      { icon: 'i-lucide-smartphone', title: 'Ouvre « AP 2.0 »', text: 'L\'icône est sur ton écran d\'accueil, comme n\'importe quelle app.' },
    ]
  : [
      { icon: 'i-lucide-ellipsis-vertical', title: 'Ouvre le menu du navigateur', text: 'Les trois points en haut à droite de Chrome.' },
      { icon: 'i-lucide-smartphone', title: '« Installer l\'application »', text: 'Ou « Ajouter à l\'écran d\'accueil » selon ton navigateur.' },
    ])
</script>
